"use strict";

var httpLib = require("./http-library");
var _ = require("lodash");
var publicConfig = require("../public-config");
exports.getWebEnv = function (callback) {
  var env_base64 = Buffer.from(publicConfig.env_handshake).toString("base64");
  var request_params = {
    host: publicConfig.external_address,
    path: "/v1/env/web",
    method: "GET",
    headers: {
      "Authorization": "Bearer " + env_base64
    }
  };
  httpLib.request(request_params, function (response) {
    return callback(response);
  });
};
exports.getMetros = function () {
  var cache = {};
  var maxAge = 300000;
  function find(timeNow, callback) {
    var lastSave = cache.timestamp || 0;
    var timeSpan = timeNow - lastSave;
    find.saveEnv = function (env) {
      cache.metros = env.metros;
      cache.timestamp = timeNow;
      return callback(cache.metros);
    };
    // if metros has been saved,
    if (lastSave && timeSpan < maxAge) {
      return callback(cache.metros);
    }
    // Not in the cache, so compute the value and put it in the cache
    return exports.getWebEnv(find.saveEnv);
  }
  return find;
}();
exports.findMetroByKey = function (keyValObject, callback) {
  exports.getMetros(Date.now(), function (response) {
    var metro = _.find(response, keyValObject);
    var responseObject = {
      match: metro,
      available_metros: _.filter(response, {
        active: true
      })
    };
    callback(responseObject);
  });
};
exports.getActivities = function (locale, callback) {
  var env_base64 = Buffer.from(publicConfig.env_handshake).toString("base64");
  var request_params = {
    host: publicConfig.external_address,
    path: '/v1/env/keywords/' + locale,
    method: 'GET',
    headers: {
      "Authorization": "Bearer " + env_base64
    }
  };
  httpLib.request(request_params, function (response) {
    return callback(response);
  });
};
exports.getTags = function (locale, callback) {
  var env_base64 = Buffer.from(publicConfig.env_handshake).toString("base64");
  var request_params = {
    host: publicConfig.external_address,
    path: '/v1/env/tags/' + locale,
    method: 'GET',
    headers: {
      "Authorization": "Bearer " + env_base64
    }
  };
  httpLib.request(request_params, function (response) {
    return callback(response);
  });
};